/**
 * Created by inonstelman on 12/28/14.
 */

(function () {
    'use strict';

    // @ngInject
    Services.autosize = function autosize($window) {
        return $window.autosize;
    };

}());
